import { render, staticRenderFns } from "./multipleDayChip.vue?vue&type=template&id=4b61ba49&"
import script from "./multipleDayChip.vue?vue&type=script&lang=js&"
export * from "./multipleDayChip.vue?vue&type=script&lang=js&"
import style0 from "./multipleDayChip.vue?vue&type=style&index=0&id=4b61ba49&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports